import React, { useState } from 'react';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ReCAPTCHA from "react-google-recaptcha";

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [captchaValue, setCaptchaValue] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const recaptchaRef = React.useRef(null);
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  
  // Debug logging for environment variables
  React.useEffect(() => {
    console.log('Contact page environment variables:', {
      siteKey: siteKey ? 'present' : 'missing',
      apiUrl: import.meta.env.VITE_API_URL
    });
  }, [siteKey]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCaptchaResponseChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (siteKey && !captchaValue) {
      setSnackbarMessage("Vul alstublieft de CAPTCHA in.");
      setOpenSnackbar(true);
      return;
    }

    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setSnackbarMessage("Vul alstublieft alle velden in.");
      setOpenSnackbar(true);
      return;
    }

    setIsSubmitting(true);
    
    try {
      const apiUrl = `${import.meta.env.VITE_API_URL}/contact`;
      const response = await axios.post(apiUrl, { 
        ...formData,
        captchaValue: captchaValue 
      });
      
      setSnackbarMessage(response.data.message || "Bericht succesvol verzonden!");
      setOpenSnackbar(true);
      
      // Reset form
      setFormData({ name: '', email: '', message: '' });
      setCaptchaValue(null);
      recaptchaRef.current?.reset();
      
    } catch (error) {
      let errorMessage = "Er ging iets mis. Probeer het later nog eens.";

      if (error.response && error.response.data) {
        if (error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data.errors && error.response.data.errors.length > 0) {
          const firstError = error.response.data.errors[0];
          errorMessage = firstError.msg || firstError.message;
        }
      }
      
      setSnackbarMessage(errorMessage);
      setOpenSnackbar(true);
      recaptchaRef.current?.reset();
      setCaptchaValue(null);

      console.error('Error submitting contact form:', error.response ? error.response.data : error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      <h1>Contact</h1>
      <h2 className="contact-header">Hoe kan ik u verder helpen?</h2>
      <p>Heeft u vragen over hoe ik uw organisatie verder kan helpen of wilt u gewoon iets kwijt over de verhaaltjes. Neem gerust contact met mij op. Ik sta altijd open voor een gesprek.</p>

      <form className="contact-form-block" onSubmit={handleSubmit}>
        <input 
          type="text" 
          name="name"
          placeholder="Wat is uw naam?" 
          value={formData.name}
          onChange={handleInputChange}
          required
        />
        <input 
          type="email" 
          name="email"
          placeholder="Uw email adres?" 
          value={formData.email}
          onChange={handleInputChange}
          required
        />
        <textarea 
          name="message"
          placeholder="Waar kan ik u mee helpen?"
          value={formData.message}
          onChange={handleInputChange}
          required
        ></textarea>
        
        {siteKey ? (
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={siteKey}
            onChange={handleCaptchaResponseChange}
            style={{ marginBottom: '16px' }}
          />
        ) : (
          <div style={{ marginBottom: '16px', padding: '8px', backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
            reCAPTCHA configuration missing. Please check environment variables.
          </div>
        )}
        
        <button 
          type="submit" 
          className="blue-button"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Bezig met verzenden...' : 'Verstuur'}
        </button>
      </form>

      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        message={snackbarMessage}
        action={
          <>
            <IconButton size="small" aria-label="close" color="inherit" onClick={() => setOpenSnackbar(false)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      />
    </div>
  );
}

export default Contact;
